export function useNativeProps() {
	return {};
}
